import { IDirectDebitPaymentProfileItem } from 'modules/PaymentProfile';
import { parse } from 'query-string';
import { v4 } from 'uuid';
import { Region } from 'stores/type';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

const NZ_TIMEZONE = 'Pacific/Auckland';
const CHATHAM_TIMEZONE = 'Pacific/Chatham';
const NZ_TIMEZONE_OFFSET = -720;
const CHATHAM_TIMEZONE_OFFSET = -765;
const MY_DOT_AU_DOMAIN_SUFFIX = 'com.au';
const MY_DOT_NZ_DOMAIN_SUFFIX = 'co.nz';
const SME_AU_DOMAIN_FLAG = '/au/';
const SME_NZ_DOMAIN_FLAG = '/nz/';

export const removeQueryString = (origin: string): string => {
    let url: URL;
    try {
        url = new URL(origin);
    } catch {
        return '';
    }
    return url.origin + url.pathname;
};

export const insertIntoString = (originString: string, insertIndex: number, newItem: string): string => {
    return [originString.slice(0, insertIndex), newItem, originString.slice(insertIndex)].join('');
};

export const generateNZDirectDebitDetail = (paymentItem: IDirectDebitPaymentProfileItem): string => {
    let nzString = paymentItem.direct_debit.bsb + paymentItem.direct_debit.account_number;
    nzString = insertIntoString(nzString, 13, '-');
    nzString = insertIntoString(nzString, 6, '-');
    nzString = insertIntoString(nzString, 2, '-');
    return nzString;
};
export const generateAUDirectDebitDetail = (paymentItem: IDirectDebitPaymentProfileItem): string => {
    return `${paymentItem.direct_debit.bsb}-${paymentItem.direct_debit.account_number}`;
};

export const isBusinessIdChanged = (search: string) => {
    console.log(localStorage.getItem('businessId'));

    if (search) {
        const parsedUrlQuery = parse(search);
        const businessId = parsedUrlQuery.businessId;
        const storedId = localStorage.getItem('businessId');

        console.log(storedId, parsedUrlQuery);
        return businessId && businessId !== storedId;
    }

    return false;
};
export const openInNewTab = (url: string) => {
    window.open(url, '_blank');
};

export function generateUUID() {
    return v4();
}

export function isIOS() {
    return (
        ['iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
}
const saveFile = (url: string, filename: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
};

export function downloadPdf(blob: Blob, filename: string) {
    const newBlob = new Blob([blob], { type: 'application/pdf' });
    const shouldSaveOnIE = () => window.navigator && window.navigator.msSaveOrOpenBlob;

    if (shouldSaveOnIE()) {
        window.navigator.msSaveOrOpenBlob(newBlob);
    } else {
        const data = window.URL.createObjectURL(newBlob);

        saveFile(data, `${filename}.pdf`);
        if (!isIOS()) {
            window.URL.revokeObjectURL(data);
        }
    }
}

export function inIframe(): boolean {
    return window.self !== window.top;
}

export function isIE() {
    return navigator.userAgent.indexOf('Trident/') > -1;
}

export const isInNZ = () => {
    const date = new Date();
    const tz = date.getTimezoneOffset();
    return tz === NZ_TIMEZONE_OFFSET || tz === CHATHAM_TIMEZONE_OFFSET;
};

export const getRegion = () => {
    const referrer = document.referrer.toLowerCase();
    if (referrer.includes(MY_DOT_AU_DOMAIN_SUFFIX) || referrer.includes(SME_AU_DOMAIN_FLAG)) {
        return Region.AU;
    }
    if (referrer.includes(MY_DOT_NZ_DOMAIN_SUFFIX) || referrer.includes(SME_NZ_DOMAIN_FLAG)) {
        return Region.NZ;
    }
    if (isIE()) {
        return isInNZ() ? Region.NZ : Region.AU;
    }
    const tz = dayjs.tz.guess();
    return tz.includes(NZ_TIMEZONE) || tz.includes(CHATHAM_TIMEZONE) ? Region.NZ : Region.AU;
};
